<div class="box-mini col" [ngClass]="{nodata: !isDataAvailable}">
    <div class="box-mini__icon"><img src="/assets/img/sura-icon-circle-stadistics.svg" alt="Sura Icon Stadistics" /></div>
    <!---->
    <div class="box-mini__title" style="margin-bottom: 0">
        <h4 style="margin-bottom: 0">Kilómetros recorridos en los últimos 6 meses</h4>
    </div>
    <!-- <iframe class="chartjs-hidden-iframe" tabindex="-1" style="display: block; overflow: hidden; border: 0px; margin: 0px; top: 0px; left: 0px; bottom: 0px; right: 0px; height: 100%; width: 100%; position: relative; pointer-events: none; z-index: -1;"></iframe> -->
    <div>
        <canvas id="bar-chart" class="hide" style="position: relative; width: 250px; height: 130px;"></canvas>
    </div>
    <div class="box-mini__btn" *ngIf="item.thereIsKms"><a class="button button-secondary button-small" (click)='logEventVerTodos()' [routerLink]="['/viajes']">VER TODOS</a></div>

    <div class="box-mini__desc-data" *ngIf="!item.thereIsKms"><img class="info-data" src="/assets/img/sura-icon-info-nodata.svg" alt="SURA ICON INFO NO DATA" />
        <p>No tienes kilómetros registrados en el mes anterior.</p>
    </div>
</div>